import {Service} from './';

export class AppConfigService extends Service {

  static entity: string = 'app/config';

  static getColumnConfigDefault(registerInvoiceId: string): Promise<any> {
    return this.axios.get(`${this.entity}/tenant-invoice-settings/${registerInvoiceId}`).then(res => res.data);
  }

  static getColumnConfig(params: any): Promise<any> {
    return this.axios.get(`${this.entity}`, {params}).then(res => res.data);
  }

  static setColumnConfig(data: any): Promise<any> {
    return this.axios.put(`${this.entity}`, data).then(res => res.data);
  }

  static restoreColumnConfig(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/revert-config-default`, {params}).then(res => res.data);
  }

}
